import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
// import './registerServiceWorker'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { locales } from '../src/locales/langs'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.prototype.bus = new Vue()

Vue.use(VueSweetalert2)
Vue.config.productionTip = false

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

Vue.use(VueI18n)
Vue.use(VueAxios, axios)

const i18n = new VueI18n({
  locale: 'en',
  messages: locales
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (window.localStorage.getItem('login')) {
      next()
    } else {
      next({ path: '/admin' })
    }
  }

  if (to.name === 'login' && window.localStorage.getItem('login')) {
    next({ path: '/' })
  }
  if (from.name === 'exam.editor' && to.name === 'exam.editor') {
    if (!window.localStorage.getItem('login')) {
      next({ path: '/' })
    }
  }
  next()
})
